module.exports = __webpack_public_path__ + "static/media/time.f704b852.svg";